<div class="card">
  <app-header titulo="Nota" descricao="Dados de Notas"></app-header>
  <p-toast />
  <p-table [value]="notas" dataKey="id" [loading]="loading" #dt [globalFilterFields]="['empresaErp','ordem','tipoPropriedade','contaContabil','centroCusto','materialErp','cdProcesso']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
    <ng-template pTemplate="caption">
      <div class="flex">
        <a [routerLink]="['novo']"><button icon="pi pi-plus" label="Novo Cadastro" pButton></button></a>

        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Empresa Erp</th>
            <th>Ordem</th>
            <th>Tipo propriedade</th>
            <th>Conta Contabil</th>
            <th>Centro de custo</th>
            <th>Material ERP</th>
            <th>Código Processo</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-nota>
        <tr>
            <td>{{ nota.empresaErp }}</td>
            <td>{{ nota.ordem }}</td>
            <td>{{ nota.tipoPropriedade }}</td>
            <td>{{ nota.contaContabil }}</td>
            <td>{{ nota.centroCusto }}</td>
            <td>{{ nota.materialErp }}</td>
            <td>{{ nota.cdProcesso }}</td>
            <td>
              <a [routerLink]="['editar', nota.id]">
                <p-button icon="pi pi-pencil"
                          severity="primary"
                          class="m-2"
                          [rounded]="true"
                          [outlined]="true" >
                </p-button>
              </a>

              <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        [rounded]="true"
                        [outlined]="true"
                        (onClick)="confirmarExclusao(nota.id)" />
            </td>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="10">Nenhum registro encontrado</td>
    </ng-template>
  </p-table>
  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
